import React, { FC, useState } from 'react';

import { useBreakpoint } from '../hooks/useBreakpoint';
import { Breakpoint } from '../utils/breakpoint';

export interface IWithHoverIconProps {
  defaultFill: string;
  defaultFillBg: string;
  hoverFill: string;
  hoverFillBg: string;
  disabled?: boolean;
}

export const withHoverIcon = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const WithHoverIcon: FC<P & IWithHoverIconProps> = ({
    defaultFill,
    defaultFillBg,
    hoverFill,
    hoverFillBg,
    disabled = false,
    ...props
  }) => {
    const [isHovered, setIsHovered] = useState(false);
    const breakpoint = useBreakpoint();
    const isShowHover = breakpoint > Breakpoint.Md && isHovered && !disabled;

    const hoverProps = disabled
      ? {}
      : {
          onMouseEnter: () => setIsHovered(true),
          onMouseLeave: () => setIsHovered(false),
        };

    return (
      <div {...hoverProps}>
        <WrappedComponent
          {...(props as P)}
          fill={isShowHover ? hoverFill : defaultFill}
          fillBg={isShowHover ? hoverFillBg : defaultFillBg}
        />
      </div>
    );
  };

  return WithHoverIcon;
};
